<template>
  <div class="faq-item">
    <div class="row">
      <div class="col-7">
        <div class="faq-data">
          <div class="faq-icon mr-1">
            <i class="icon" :class="iconType"></i>
          </div>
          <div class="faq-info">
            <h4 class="faq-name typo-paragraph12 typo-medium mb-half">{{ faqName }}</h4>
            <p class="faq-time typo-paragraph10 typo-regular">{{ $t("search.last")}}</p>
          </div>
        </div>
      </div>
      <div class="col-2 ml-auto">
        <a :href="item.previewUrl" target="_blank" class="btn btn-clean faq-action" @click.stop>
          <i class="icon icon-view"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "PageResult",
  props: {
    type: String,
    item: Object
  },
  computed: {
    faqName() {
      if (this.item && this.item.title)
        return this.item.title;
      return "";
    },
  }

}
</script>

<style lang="scss" scoped>
.faq-item {
  padding: 9px 16px 10px 16px;
  .faq-data {
    display: flex;
    align-items: center;
  }
  .faq-icon {
    font-size: 20px;
    color: #DADADA;
  }
  .faq-info {
    // display: block;
    max-width: calc(100% - 8px - 20px);
  }
  .faq-name {
    color: $textLightModeHigh;
    display: block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .faq-time {
    color: $textLightModeLow;
  }
  .faq-action {
    font-size: 16px;
    width: 32px;
    height: 32px;
    padding: 8px;
    margin-left: auto;
    border-radius: $radius;
    color: $textLightModeHigh;
    @include trans-all;
    &:hover {
      background: $textDarkModeHigh;
      color: $textLightModeHigh;
    }
  }

  &:hover {
    background: $light2;
    cursor: pointer;
  }
}
</style>
